import { Route, Routes } from "react-router";

import NotFoundPage from "components/error/NotFoundPage";
import useIsLearnViewAvailable from "hooks/useIsLearnViewAvailable";
import useIsOnboardingCertificatesAvailable from "hooks/useIsOnboardingCertificatesAvailable";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

import LaunchPadBoard from "./Board";
import LaunchPadTrack from "./Track";
import LaunchPadUserGuidesGroup from "./UserGuidesGroup";

const LaunchPad = () => {
  const { viewer } = useTypedContext(AccountContext);
  const isOnboardingCertificatesAvailable = useIsOnboardingCertificatesAvailable();

  if (!useIsLearnViewAvailable()) {
    return <LaunchPadBoard />;
  }

  return (
    <Routes>
      <Route index element={<LaunchPadBoard />} />
      <Route path="/learn/:userGuideGroupId">
        <Route index path="*" element={<LaunchPadUserGuidesGroup />} />
      </Route>
      {viewer.admin && isOnboardingCertificatesAvailable && (
        <Route path="track" element={<LaunchPadTrack />} />
      )}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default LaunchPad;
